import {
  DropDTO,
  WellLayerIngredientDTO,
  DropLayerDTO,
  LayerTypeDTO,
} from 'business/models/Models';

import { isNullOrUndefined } from 'utils/Global';
import EVolumetricLayerDispense from './EVolumetricLayerDispense';
import EVolumetricLayerType from './EVolumetricLayerType';
import { VolumetricLayerKey } from './VolumetricLayerKey';
import { VolumetricWellDropLayers } from './VolumetricWellDropLayers';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';

export class VolumetricWellDropLayer {
  private key: VolumetricLayerKey;
  private readonly Layers: VolumetricWellDropLayers;
  private wellDropLayers: DropLayerDTO[];
  private docData: ExperimentDtoClient;

  constructor(
    docData: ExperimentDtoClient,
    layers: VolumetricWellDropLayers,
    dispense: EVolumetricLayerDispense,
    type: EVolumetricLayerType,
    wellDropLayers: DropLayerDTO[],
  ) {
    const layersIDs = wellDropLayers.map((wellDropLayer) => wellDropLayer.layerId);
    this.docData = docData;
    this.key = new VolumetricLayerKey({ dispense, type, layersIDs });
    this.Layers = layers;
    this.wellDropLayers = wellDropLayers;
  }

  public get Key(): VolumetricLayerKey {
    return this.key;
  }

  public get WellDropRow(): DropDTO {
    return this.Layers.WellDropRow;
  }

  public GetFirstWellDropLayerRow(): DropLayerDTO {
    return this.wellDropLayers[0];
  }

  public get WellID(): number {
    return this.Layers.WellID;
  }

  public get Volume(): number {
    return this.wellDropLayers[0].volume;
  }

  public set Volume(value) {
    for (const wellDropLayer of this.wellDropLayers) {
      wellDropLayer.volume = value;
    }
  }

  public get WaterVolume(): number {
    return this.wellDropLayers[0].waterVolume;
  }

  public set WaterVolume(value) {
    for (const wellDropLayer of this.wellDropLayers) {
      wellDropLayer.waterVolume = value;
    }
  }

  public IsSourceWellIDNull(): boolean {
    return isNullOrUndefined(this.wellDropLayers[0]);
  }

  public get SourceWellID(): number {
    return this.wellDropLayers[0].sourceWellId;
  }

  public set SourceWellID(value) {
    for (const wellDropLayer of this.wellDropLayers) {
      wellDropLayer.sourceWellId = value;
    }
  }

  public get SourceWellRow(): number {
    return this.wellDropLayers[0].sourceWellId;
  }

  public set SourceWellRow(value) {
    for (const wellDropLayer of this.wellDropLayers) {
      wellDropLayer.sourceWellId = value;
    }
  }

  public IsSourcePlateIDNull(): boolean {
    return this.IsSourceWellIDNull();
  }

  public IsWaterSourceNull(): boolean {
    return isNullOrUndefined(this.wellDropLayers[0]);
  }

  public SetWaterSourceNull(): void {
    for (const wellDropLayer of this.wellDropLayers) {
      wellDropLayer.waterSource = null;
    }
  }

  public get WaterSource(): string {
    return this.wellDropLayers[0].waterSource;
  }

  public set WaterSource(value) {
    for (const wellDropLayer of this.wellDropLayers) {
      wellDropLayer.waterSource = value;
    }
  }

  public IsProteinLayer(): boolean {
    const layer = this.docData.layers.find(
      (layer) => layer.id === this.wellDropLayers[0].layerId,
    );
    return LayerTypeDTO.Protein == layer.type;
  }

  public IsSeedLayer(): boolean {
    const layer = this.docData.layers.find(
      (layer) => layer.id === this.wellDropLayers[0].layerId,
    );
    return LayerTypeDTO.Seed == layer.type;
  }

  wellDropLayerIngredientRows: WellLayerIngredientDTO[];
  public GetIngredientRows(): WellLayerIngredientDTO[] {
    if (this.wellDropLayerIngredientRows == null) {
      this.wellDropLayerIngredientRows = new Array<WellLayerIngredientDTO>();
      for (const wellDropLayerRow of this.wellDropLayers) {
        this.wellDropLayerIngredientRows = [...wellDropLayerRow.dropLayerIngredientList];
      }
    }
    return this.wellDropLayerIngredientRows;
  }

  public static GetRobotLayer(docData, wellDropRow): VolumetricWellDropLayer {
    const layers: VolumetricWellDropLayers = VolumetricWellDropLayers.GetRobotLayers(
      docData,
      wellDropRow,
    );
    if (layers.IsSingleLayer()) {
      return layers.SingleLayer;
    }
    return null;
  }

  public static GetLayer(
    docData,
    wellDropRow,
    key: VolumetricLayerKey,
  ): VolumetricWellDropLayer {
    return VolumetricWellDropLayers.GetWellDropLayers(docData, wellDropRow).GetLayer(key);
  }
}
